import React, { useState, useEffect } from "react";
import "./CalculoComissoes.css"; // Arquivo CSS para estilização

function CalculoComissoes() {
    const [indicadores, setIndicadores] = useState([]);
    const [indicador, setIndicador] = useState("");
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [comissoes, setComissoes] = useState([]);
    const [total, setTotal] = useState(0);
    const [error, setError] = useState("");

    // 🔹 Buscar indicadores ao carregar a página
    useEffect(() => {
        const fetchIndicadores = async () => {
            try {
                const response = await fetch("https://welaunchyou.com.br/crm-wly/listar_indicadores.php");
                const data = await response.json();
                if (data.indicadores) {
                    setIndicadores(data.indicadores);
                } else {
                    setError("Erro ao carregar indicadores.");
                }
            } catch (error) {
                setError("Erro ao conectar ao servidor.");
            }
        };
        fetchIndicadores();
    }, []);

    // 🔹 Calcular comissões
    const handleCalcular = async () => {
        console.log("📡 Clicou em Calcular"); // Verifica se o botão está chamando a função
        
        if (!indicador || !mes || !ano) {
            alert("Por favor, selecione todos os filtros.");
            return;
        }
    
        try {
            const response = await fetch(
                `https://welaunchyou.com.br/crm-wly/api/financeiro/calculo_comissoes.php?indicador_id=${indicador}&mes=${mes}&ano=${ano}`
            );
            const data = await response.json();
    
            console.log("📡 Resposta da API de Comissões:", data); // 🔹 Verifica a resposta no console
    
            if (data.error) {
                alert(`Erro: ${data.error}`);
                return;
            }

            // Permite edição da comissão armazenando cada item como um objeto
            const comissoesEditaveis = data.comissoes.map((c) => ({
                cliente: c.cliente,
                valor: parseFloat(c.valor).toFixed(2),
                comissao: parseFloat(c.comissao).toFixed(2),
            }));

            setComissoes(comissoesEditaveis);
            setTotal(data.total_comissao || 0);
        } catch (error) {
            console.error("Erro ao conectar à API:", error);
            alert("Erro ao conectar ao servidor.");
        }
    };

    // 🔹 Atualiza o valor da comissão manualmente
    const handleComissaoChange = (index, novoValor) => {
        const novasComissoes = [...comissoes];
        novasComissoes[index].comissao = novoValor;

        setComissoes(novasComissoes);
        calcularTotal(novasComissoes);
    };

    // 🔹 Recalcula o total das comissões após alterações
    const calcularTotal = (comissoesAtualizadas) => {
        const novoTotal = comissoesAtualizadas.reduce((acc, c) => acc + parseFloat(c.comissao || 0), 0);
        setTotal(novoTotal);
    };

    // 🔹 Exportar comissões atualizadas
    const handleExportarPDF = () => {
        const params = new URLSearchParams();
        params.append("indicador_id", indicador);
        params.append("mes", mes);
        params.append("ano", ano);

        comissoes.forEach((c, index) => {
            params.append(`comissoes[${index}][cliente]`, c.cliente);
            params.append(`comissoes[${index}][valor]`, c.valor);
            params.append(`comissoes[${index}][comissao]`, c.comissao);
        });

        window.open(`https://welaunchyou.com.br/crm-wly/api/financeiro/exportar_comissoes.php?${params.toString()}`, "_blank");
    };

    return (
        <div><h1 className="comissoes-titulo">Cálculo de Comissões</h1>
        <div className="comissoes-container">


            <div className="comissoes-filtros">
                <label>Indicado por:</label>
                <select value={indicador} onChange={(e) => setIndicador(e.target.value)} className="comissoes-select">
                    <option value="">Selecione</option>
                    {indicadores.map((ind) => (
                        <option key={ind.id} value={ind.id}>
                            {ind.nome}
                        </option>
                    ))}
                </select>

                <label>Mês:</label>
<select value={mes} onChange={(e) => setMes(e.target.value)} className="comissoes-select">
    <option value="">Selecione</option>
    {[
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", 
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ].map((nomeMes, index) => (
        <option key={index + 1} value={index + 1}>
            {nomeMes}
        </option>
    ))}
</select>


                <label>Ano:</label>
                <select value={ano} onChange={(e) => setAno(e.target.value)} className="comissoes-select">
                    <option value="">Selecione</option>
                    {[2025].map((a) => (
                        <option key={a} value={a}>
                            {a}
                        </option>
                    ))}
                </select>

                <button onClick={handleCalcular} className="comissoes-botao">Calcular</button>
            </div>

            {error && <p className="comissoes-error">{error}</p>}

            {comissoes.length > 0 && (
                <div className="comissoes-tabela-container">
                    <table className="comissoes-tabela">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Valor Pago</th>
                                <th>Comissão</th>
                            </tr>
                        </thead>
                        <tbody>
    {comissoes.map((c, index) => (
        <tr key={index}>
            <td>{c.cliente}</td>
            <td>R$ {parseFloat(c.valor).toFixed(2)}</td>
            <td>
            <input
  type="number"
  id={`comissao-${index}`}
  value={comissoes[index].comissao}
  className="comissao-input"
  onChange={(e) => handleComissaoChange(index, e.target.value)}
/>

            </td>
        </tr>
    ))}
</tbody>

                        <tfoot>
                            <tr>
                                <td colSpan="2">Total de Comissões:</td>
                                <td>R$ {parseFloat(total).toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>

                    <button
    onClick={() => {
        const dadosExportacao = comissoes.map((c, index) => {
            const inputElement = document.getElementById(`comissao-${index}`);
            return {
                cliente: c.cliente,
                valor: c.valor,
                comissao: inputElement ? parseFloat(inputElement.value) || 0 : c.comissao
            };
        });

        const url = `https://welaunchyou.com.br/crm-wly/api/financeiro/exportar_comissoes.php`;

        const form = document.createElement("form");
        form.method = "POST";
        form.action = url;
        form.target = "_blank";

        const inputIndicador = document.createElement("input");
        inputIndicador.type = "hidden";
        inputIndicador.name = "indicador";
        inputIndicador.value = indicador;
        form.appendChild(inputIndicador);

        const inputMes = document.createElement("input");
        inputMes.type = "hidden";
        inputMes.name = "mes";
        inputMes.value = mes;
        form.appendChild(inputMes);

        const inputAno = document.createElement("input");
        inputAno.type = "hidden";
        inputAno.name = "ano";
        inputAno.value = ano;
        form.appendChild(inputAno);

        const inputComissoes = document.createElement("input");
        inputComissoes.type = "hidden";
        inputComissoes.name = "comissoes";
        inputComissoes.value = JSON.stringify(dadosExportacao);
        form.appendChild(inputComissoes);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }}
    className="comissoes-exportar"
>
    Exportar PDF
</button>


                </div>
            )}
        </div>
        </div>
    );
}

export default CalculoComissoes;
